import {BASE_API} from '../../utils/constantes'
import { getToken } from './token'
import { withCache, TTL } from '../../services/apiCache'

// Función original sin caché
async function _getLocalidades(request_get){
    try {
        
        const url =  `${BASE_API}/api/localidad/?${request_get}`
            
        const params = {
            headers:{
                Authorization:`Bearer ${getToken()}`
            }
        }
        const response = await fetch(url,params)
        if(response.status === 200){
           
            const result= await response.json()
            
            return result
            
        }
        return false
        
    } catch (error) {
        throw new Error ("Credenciales invalidas")
    }
}

// Función exportada con caché (30 minutos de TTL)
export const getLocalidades = withCache(_getLocalidades, TTL.MEDIUM, (request_get, forceRefresh) => {
    return `getLocalidades_${request_get || ''}_${forceRefresh || ''}`;
});